import { useDispatch } from "react-redux"
import { optimisticEntityDelete } from "../../actions/entities"

export const useDeleteEntity = () => {
  const dispatch = useDispatch()
  return (entity: string, id: number) =>
    dispatch(optimisticEntityDelete(entity, id, {}))
}
